export const BASE_TABLE_DEFINITION_VER = "1.0";
export const DETAIL_FILL_TABLE_DEFINITION_VER = "1.1";
export const FIND_ORDERS_TABLE_DEFINITION_VER = "1.2";
export const FIND_TRADE_TABLE_DEFINITION_VER = "1.0";
export const RISK_TRADE_TABLE_DEFINITION_VER = "1.0";
export const ALGO_RISK_TRADE_TABLE_DEFINITION_VER = "1.1";
export const INBOX_TABLE_DEFINITION_VER = "1.2";
export const INTERVENTION_TABLE_DEFINITION_VER = "1.0";
export const MULTI_ASSET_TABLE_DEFINITION_VER = "1.0";
export const ORDER_LADDER_TABLE_DEFINITION_VER = "1.7";
export const ALGO_MONITOR_TABLE_DEFINITION_VER = "1.1";
export const ORDERS_TABLE_DEFINITION_VER = "1.5";
export const TRADE_TABLE_DEFINITION_VER = "1.0";
export const HEDGE_ORDERS_TABLE_DEFINITION_VER = "1.1";
export const SPOT_RISK_TABLE_DEFINITION_VER = "1.0";
export const FWD_RISK_TABLE_DEFINITION_VER = "1.0";
export const BM_AUDIT_TABLE_DEFINITION_VER = "1.0";
export const HOMS_TABLE_DEFINITION_VER = "1.1";
export const FWD_ROLL_ORDERS_TABLE_DEFINITION_VER = "1.0";
export const FWD_ROLL_CCYS_TABLE_DEFINITION_VER = "1.0";
export const FWD_ROLL_PAIRS_TABLE_DEFINITION_VER = "1.0";
export const ALLOCATION_TABLE_DEFINITION_VER = "1.0";

export const COLUMN_PRIVATIZATION: string = "__bfx_privatization";
export const COLUMN_SELECTION = "selection";

// Icons shown in spot risk for recent fixing (as selection column will be hidden)
export const COLUMN_ICONS = "icons";
